import $ from 'jquery';

$(document).ready(function () {
    $.fn.focus_end = function () {
        this.focus();
        let $thisVal = this.val();
        this.val('').val($thisVal);
        return this;
    };

    function create_cookie(name, value, days) {
        let expires;

        if (days) {
            let date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            expires = '; expires=' + date.toGMTString();
        } else {
            expires = '';
        }

        document.cookie =
            encodeURIComponent(name) +
            '=' +
            encodeURIComponent(value) +
            expires +
            '; path=/';
    }

    function read_cookie(name) {
        let nameEQ = encodeURIComponent(name) + '=';
        let ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0)
                return decodeURIComponent(c.substring(nameEQ.length, c.length));
        }
        return null;
    }

    function copy(text) {
        let temp = $('<input>');

        $('body').append(temp);

        temp.val(text).select();
        document.execCommand('copy');

        temp.remove();
    }

    function parse_url(url) {
        let a = document.createElement('a');
        a.href = url;

        return {
            href: a.href,
            host: a.host,
            hostname: a.hostname,
            port: a.port,
            pathname: a.pathname,
            protocol: a.protocol,
            hash: a.hash,
            search: a.search,
        };
    }

    const tooltip = $('[data-tooltip]');

    $(window).on('resize', function () {
        tooltip.tooltip('update');
    });

    $(document).on(
        {
            mouseenter: function () {
                $(this).tooltip({
                    content: $(this).data('tooltip-content'),
                    gap: 12,
                });
            },
            mouseleave: function () {
                $(this).tooltip('close');
            },
        },
        '[data-tooltip]'
    );

    const load_more_trigger = function () {
        // Place js code for trigger ajax load more buttons
    };

    $(document).on('click', '[data-copy]', function () {
        let button = $(this),
            text = button.attr('data-url'),
            first_title = button.attr('aria-label');

        copy(text);

        // eslint-disable-next-line no-undef
        button.attr('aria-label', ideabox_object.copied);

        setTimeout(function () {
            button.attr('aria-label', first_title);
        }, 3000);
    });

    $('.dark-mode-switcher').on('click', (e) => {
        e.stopPropagation();
        e.preventDefault();

        let check = read_cookie('ib_dark_mode');

        if (check === 'on') {
            create_cookie('ib_dark_mode', 'off');
        } else {
            create_cookie('ib_dark_mode', 'on');
        }

        window.location.reload();
    });

    $(window).scroll(function () {
        if ($(this).scrollTop()) {
            $('.go-top').addClass('scale-1');
        } else {
            $('.go-top').removeClass('scale-1');
        }
    });

    $('.go-top').click(function () {
        $('html, body').animate({ scrollTop: 0 }, 300);
    });

    let ib_light_box = () => {
        // eslint-disable-next-line no-undef
        if ('true' === ideabox_theme_object.light_box) {
            let block_gallery = $('.wp-block-gallery'),
                classic_gallery = $('.gallery'),
                ib_gallery = $('.ideabox-gallery'),
                light_boxes = $(
                    'a[href$=".jpg"], a[href$=".jpeg"], a[href$=".png"], a[href$=".gif"]'
                );

            light_boxes.attr('data-fancybox', '').fancybox();

            block_gallery.each(function (i) {
                $(this).attr('data-block-gallery', i);
                let gallery_items = $('[data-block-gallery=' + i + ']').find(
                    'a[href$=".jpg"], a[href$=".jpeg"], a[href$=".png"], a[href$=".gif"]'
                );
                gallery_items
                    .attr('data-fancybox', 'block-gallery-' + i)
                    .fancybox();
            });

            classic_gallery.each(function (i) {
                $(this).attr('data-classic-gallery', i);
                let gallery_items = $('[data-classic-gallery=' + i + ']').find(
                    'a[href$=".jpg"], a[href$=".jpeg"], a[href$=".png"], a[href$=".gif"]'
                );
                gallery_items
                    .attr('data-fancybox', 'classic-gallery-' + i)
                    .fancybox();
            });

            ib_gallery.each(function (i) {
                $(this).attr('data-ib-gallery', i);
                let gallery_items = $('[data-ib-gallery=' + i + ']').find(
                    'a[href$=".jpg"], a[href$=".jpeg"], a[href$=".png"], a[href$=".gif"]'
                );
                gallery_items
                    .attr('data-fancybox', 'ib-gallery-' + i)
                    .fancybox();
            });
        }
    };

    ib_light_box();

    let search_bar = function (action = 'toggle') {
        let search = $('.search-bar'),
            hide_search_fields = $(
                '.logo-box, .toggle-sidebar, .header-menu, .header-right'
            );

        if ('toggle' === action) {
            if (search.hasClass('active')) {
                search.removeClass('active');
                hide_search_fields.css('opacity', 1);
            } else {
                search.addClass('active');
                hide_search_fields.css('opacity', 0);
                setTimeout(function () {
                    $('.ib-search-input').focus_end();
                }, 200);
            }
        }

        if ('close' === action) {
            search.removeClass('active');
            hide_search_fields.css('opacity', 1);
        }

        if ('open' === action) {
            search.removeClass('active');
            hide_search_fields.css('opacity', 0);
            setTimeout(function () {
                $('.ib-search-input').focus_end();
            }, 200);
        }
    };

    $('.search-toggle').on('click', function () {
        close_navigate();
        search_bar();
    });

    let scrollPos = 0,
        scrollTime;
    let showHideHeader = function () {
        clearTimeout(scrollTime);

        let currentScroll = $(this).scrollTop(),
            admin_bar = $('#wpadminbar'),
            admin_bar_height = admin_bar.length ? admin_bar.height() : 0,
            sticky_header = $('.sticky-header .header'),
            sticky_header_height = sticky_header.height() + admin_bar_height;

        if (currentScroll < 60) {
            sticky_header.css('top', '0' + admin_bar_height + 'px');
        } else {
            if (currentScroll <= scrollPos) {
                sticky_header.css('top', '0' + admin_bar_height + 'px');
            } else {
                sticky_header.css('top', '-' + sticky_header_height + 'px');
                search_bar('close');
            }
        }

        scrollTime = setTimeout(function () {
            scrollPos = $(window).scrollTop();
        }, 100);
    };

    let close_navigate = function () {
        $('.overlay').hide();
        $('.sidebar').removeClass('opened');
        $('body').removeClass('fixed');
    };

    let open_navigate = function () {
        if ($(window).width() < 760) {
            $('body').addClass('fixed');
        }

        $('.overlay').show();
        $('.sidebar').addClass('opened');
    };

    $('#postCarousel').owlCarousel({
        loop: true,
        dots: true,
        nav: true,
        navText: [
            '<span><i class="material-icons">&#xE314;</i></span>',
            '<span><i class="material-icons">&#xE315;</i></span>',
        ],
        items: 1,
        responsive: {
            600: {
                margin: 20,
            },
        },
    });

    $('#widgetCarousel').owlCarousel({
        dots: true,
        nav: false,
        items: 1,
        loop: true,
    });

    $('.widget-carousel').each(function () {
        $(this).owlCarousel({
            dots: true,
            nav: true,
            items: 1,
            loop: true,
            navText: [
                '<i class="material-icons">&#xE314;</i>',
                '<i class="material-icons">&#xE315;</i>',
            ],
        });
    });

    $('#postCarousel2').owlCarousel({
        loop: true,
        dots: true,
        nav: false,
        autoplay: true,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1,
            },
            600: {
                items: 2,
                margin: 10,
            },
            900: {
                items: 3,
                margin: 10,
            },
            1100: {
                items: 4,
                margin: 10,
            },
            1400: {
                items: 5,
                margin: 10,
            },
        },
    });

    $('#postCarousel3').owlCarousel({
        loop: true,
        dots: true,
        nav: false,
        navText: [
            '<span><i class="material-icons">&#xE314;</i></span>',
            '<span><i class="material-icons">&#xE315;</i></span>',
        ],
        items: 1,
    });

    let addWaveEffect = function (self, e) {
        let wave = '.wave-effect',
            btnWidth = self.outerWidth(),
            x = e.offsetX,
            y = e.offsetY;

        self.prepend('<span class="wave-effect"></span>');

        $(wave)
            .css({ top: y, left: x })
            .animate(
                {
                    opacity: '0',
                    width: btnWidth * 2,
                    height: btnWidth * 2,
                },
                500,
                function () {
                    self.find(wave).remove();
                }
            );
    };

    $('.material-button').on('click', function (e) {
        addWaveEffect($(this), e);
    });

    $('.material-button-inner').on('click', function (e) {
        addWaveEffect($(this).find('span').first(), e);
    });

    let nextURL,
        infinite_wrapper = $('.infinite-posts'),
        pagination_check = $('.nav-previous a');

    function updateNextURL(doc) {
        nextURL = $(doc).find('.nav-previous a').attr('href');
    }

    let topSpacing;

    if ($('body').hasClass('sticky-header')) {
        topSpacing = 110;
    } else {
        if ($('body').hasClass('admin-bar')) {
            topSpacing = 82;
        } else {
            topSpacing = 50;
        }
    }

    const sticky_sidebar = $('.ib-sticky').hcSticky({
        stickTo: '.content-sidebar',
        bottom: 20,
        top: topSpacing,
        responsive: {
            960: {
                disable: true,
            },
        },
    });

    const ib_stickies = function (parent) {
        let sticky_item = $(parent).find('.article-left-box-inner');

        sticky_item.hcSticky({
            top: topSpacing,
            bottom: 0,
            responsive: {
                767: {
                    disable: true,
                },
            },
        });
    };

    ib_stickies('.article-left-box');

    /**
     * Auto load next post
     */
    if (infinite_wrapper.length && pagination_check.length) {
        updateNextURL(document);

        let $single_infinite = infinite_wrapper.infiniteScroll({
            path: function () {
                return nextURL;
            },
            append: 'article.single-post',
            status: '.page-load-status',
            hideNav: '.infinite-scroll-wrapper',
            history: 'push',
            debug: false,
            historyTitle: true,
            scrollThreshold: 600,
        });

        $single_infinite.on('history.infiniteScroll', function (
            event,
            title,
            path
        ) {
            // Google Analytics tracking
            // eslint-disable-next-line no-undef
            if ('true' === ideabox_object.ga_track) {
                let path_name = parse_url(path).pathname;
                // eslint-disable-next-line no-undef
                gtag('config', ideabox_object.ga_tracking_code, {
                    page_path: path_name,
                });
            }
        });

        $single_infinite.on('load.infiniteScroll', function (event, response) {
            updateNextURL(response);
        });

        $single_infinite.on('append.infiniteScroll', function (
            event,
            response,
            path,
            items
        ) {
            $(items).imagesLoaded(function () {
                ib_stickies(items);
                sticky_sidebar.hcSticky('update');

                // Prism.js init
                if (
                    items.length &&
                    'id' in items[0] &&
                    // eslint-disable-next-line no-undef
                    'true' === ideabox_object.prism
                ) {
                    // eslint-disable-next-line no-undef
                    Prism.highlightAllUnder(
                        document.querySelector('#' + items[0].id)
                    );
                }

                // Fancybox.js init
                ib_light_box();

                // Sharer.js init
                // eslint-disable-next-line no-undef
                if ('true' === ideabox_object.sharer) {
                    window.Sharer.init();
                }
            });
        });
    }

    let itemsWrapper = $('.posts-wrapper'),
        loadMoreButton = $('.load-more-button'),
        loadMoreWrapper = $('.load-more');

    const cleanUrl =
        document.location.protocol +
        '//' +
        window.location.hostname +
        window.location.pathname;

    const fullUrl =
        document.location.protocol +
        '//' +
        window.location.hostname +
        window.location.pathname +
        window.location.search;

    const urlParams = window.location.search.replace('?', '&');

    /**
     * Feed infinite scrolls (button, and infinite)
     */
    if (loadMoreWrapper.length) {
        /**
         * Feed infinite scroll
         */
        let $containerInfScroll = $(
            '.pagination-infinite_scroll'
        ).infiniteScroll({
            path: function () {
                let pageNumber = this.loadCount + 1;
                if (this.loadCount < itemsWrapper.data('max') - 1) {
                    if (
                        urlParams.indexOf('orderby') >= 0 ||
                        urlParams.indexOf('s') >= 0
                    ) {
                        return (
                            fullUrl + '&' + 'paged=' + parseInt(pageNumber + 1)
                        );
                    } else {
                        return (
                            cleanUrl + '?' + 'paged=' + parseInt(pageNumber + 1)
                        );
                    }
                }
            },
            append: '.feed-post',
            history: false,
            status: '.page-load-status',
        });

        $containerInfScroll.on('request.infiniteScroll', function () {
            loadMoreButton.hide();
        });

        $containerInfScroll.on('load.infiniteScroll', function () {
            loadMoreButton.show();
        });

        $containerInfScroll.on('last.infiniteScroll', function () {
            loadMoreButton.remove();
        });

        $containerInfScroll.on('append.infiniteScroll', function (
            event,
            response,
            path,
            items
        ) {
            $(items).addClass('slide-in-bottom');
            sticky_sidebar.hcSticky('update');
            load_more_trigger();
        });

        /**
         * Feed load more button
         */
        let $containerLoadMore = $('.pagination-load_more').infiniteScroll({
            path: function () {
                let pageNumber = this.loadCount + 1;
                if (this.loadCount < itemsWrapper.data('max') - 1) {
                    if (
                        urlParams.indexOf('orderby') >= 0 ||
                        urlParams.indexOf('s') >= 0
                    ) {
                        return (
                            fullUrl + '&' + 'paged=' + parseInt(pageNumber + 1)
                        );
                    } else {
                        return (
                            cleanUrl + '?' + 'paged=' + parseInt(pageNumber + 1)
                        );
                    }
                }
            },
            append: '.feed-post',
            history: false,
            status: '.page-load-status',
            button: '.load-more-button',
            scrollThreshold: false,
        });

        $containerLoadMore.on('request.infiniteScroll', function () {
            loadMoreButton.hide();
        });

        $containerLoadMore.on('load.infiniteScroll', function () {
            loadMoreButton.show();
        });

        $containerLoadMore.on('last.infiniteScroll', function () {
            loadMoreButton.remove();
        });

        $containerLoadMore.on('append.infiniteScroll', function (
            event,
            response,
            path,
            items
        ) {
            $(items).addClass('slide-in-bottom');
            sticky_sidebar.hcSticky('update');
            load_more_trigger();
        });
    }

    $('.ib-post-filter').change(function () {
        window.location = $(this).val();
    });

    let emoticons_wrapper = $('.article-emoticons > li');
    emoticons_wrapper.on('mouseover', function () {
        $(this).parent().addClass('active');
    });

    emoticons_wrapper.on('mouseleave', function () {
        $(this).parent().removeClass('active');
    });

    $(document).on('mouseover', '.add-to-favorite.not-added', function () {
        let icon = $(this).find('i'),
            filled = icon.data('filled');

        icon.html(filled);
    });

    $(document).on('mouseleave', '.add-to-favorite.not-added', function () {
        let icon = $(this).find('i'),
            outline = icon.data('outline');

        icon.html(outline);
    });

    let makeParallax = function () {
        let scrollTop = $(this).scrollTop();
        if (scrollTop < 300)
            $('.parallax-box .parallax-image').css({
                transform: 'translate3d(0px, ' + scrollTop / 2 + 'px, 0px)',
            });

        let opacity = 1;
        if (scrollTop > 10 && scrollTop < 50) opacity = 0.9;
        else if (scrollTop >= 50 && scrollTop < 100) opacity = 0.8;
        else if (scrollTop >= 100 && scrollTop < 150) opacity = 0.7;
        else if (scrollTop >= 150 && scrollTop < 200) opacity = 0.6;
        else if (scrollTop >= 200 && scrollTop < 250) opacity = 0.5;
        else if (scrollTop >= 250 && scrollTop < 300) opacity = 0.4;
        else if (scrollTop >= 300 && scrollTop < 350) opacity = 0.3;
        else if (scrollTop >= 350 && scrollTop < 400) opacity = 0.2;
        else if (scrollTop >= 400) opacity = 0;

        $('.parallax-box .post-overlay-inner').css({ opacity: opacity });
    };

    let set_content_height = function () {
        let header_height = $('.header').height(),
            sticky_header = $('.admin-bar.sticky-header .header'),
            admin_bar_height = $('#wpadminbar').height(),
            extra = $('.extra-posts');

        if (extra.length) {
            $('.sticky-header .extra-posts').css('margin-top', header_height);
        } else {
            $('.sticky-header .site-main').css('margin-top', header_height);
        }

        $('.search-bar').css({
            height: header_height,
        });

        sticky_header.css('top', admin_bar_height);
    };

    $(window)
        .on('resize', function () {
            set_content_height();
        })
        .trigger('resize');

    window.onload = function () {
        set_content_height();
    };

    makeParallax.call($(window));

    $(window).on('scroll', function () {
        showHideHeader.call(this);
        makeParallax.call(this);
    });

    $('.toggle-sidebar').on('click', function () {
        open_navigate();
    });

    $('.overlay, .sidebar-toggle-button').on('click', function () {
        close_navigate();
    });

    $('.search-close').on('click', function () {
        $('.ib-search-input').blur();
    });

    $('.w-boxed-post ul').each(function (i) {
        let wrapper = $(this);

        wrapper.addClass('w-boxed-' + i);

        let element = $('.w-boxed-' + i).find('li'),
            count = element.size(),
            inc_count = 1;

        element.on('mouseover', function () {
            element.removeClass('active');
            $(this).addClass('active');

            inc_count = $(this).index();
        });

        setInterval(function () {
            element.removeClass('active');
            element.eq(inc_count).toggleClass('active');
            inc_count++;

            if (inc_count === count) {
                inc_count = 0;
            }
        }, 5000);
    });

    $(document).on('click', function (event) {
        let click_over = $(event.target),
            sub_menu = $('.sub-menu');

        if (!click_over.parents('.sub-menu.active').length) {
            sub_menu.removeClass('active');
        }

        if (
            click_over.parents('.search-bar').length < 1 &&
            !click_over.hasClass('search-bar') &&
            !click_over.parent().hasClass('search-toggle') &&
            !click_over.hasClass('search-toggle')
        ) {
            search_bar('close');
        }
    });

    $('.header-right .submenu-toggle').on('click', function (e) {
        e.stopPropagation();
        e.preventDefault();

        let current_menu = $(this).parents('li').find('.sub-menu'),
            sub_menus = $('.sub-menu');

        sub_menus.not(current_menu).removeClass('active');

        current_menu.show().toggleClass('active');
    });

    $('.sidebar-menu li > a .multimenu-icon').on('click', function (e) {
        let link = $(this).parent(),
            firstSubMenu = link.parent().find('ul:first');

        if (firstSubMenu.length) {
            e.stopPropagation();
            e.preventDefault();
            link.parent().removeClass('active');
            if (firstSubMenu.css('display') === 'block') {
                link.parent().removeClass('active');
            } else {
                link.parent().addClass('active');
            }

            firstSubMenu.slideToggle(100);
        }
    });

    $('.sidebar-menu li.current-menu-ancestor').addClass('active');
    $('.sidebar-menu li.current-menu-ancestor > ul').show();

    let ib_modal = function (el, action) {
        let modal_box = $('.m-modal-box'),
            sub_menus = $('.sub-menu');

        if ('open' === action) {
            modal_box.hide();
            el.show();
            el.find('.m-modal-content').addClass('active');
            $('body').addClass('modal-open');
            sub_menus.removeClass('active');
        }

        if ('close' === action) {
            $('.m-modal-content').removeClass('active');

            modal_box.hide();
            $('body').removeClass('modal-open');
        }
    };

    $(document).on('click', '[data-modal]', function (e) {
        e.preventDefault();
        let modalId = $(this).attr('data-modal'),
            modal = $('#' + modalId);

        ib_modal(modal, 'open');
    });

    $(document).on('click', '.login-check', function (e) {
        e.preventDefault();
        ib_modal($('#loginModal'), 'open');
    });

    $(document).on('click', '.m-modal-close, .m-modal-overlay', function () {
        ib_modal('', 'close');
    });

    $(document).on('click', '[data-ib-scroll]', function (e) {
        e.preventDefault();
        e.stopPropagation();

        let scroll_class = $(this).attr('data-ib-scroll'),
            scroll_to = $(scroll_class);

        if (!scroll_to.length) {
            window.location.replace($(this).attr('href'));
            return;
        }

        $('html,body').animate(
            {
                scrollTop: scroll_to.offset().top,
            },
            'slow'
        );
    });

    let ib_scroll = $('.ib-scroll');
    if (ib_scroll.length) {
        ib_scroll.mCustomScrollbar({
            theme: 'minimal-dark',
        });
    }

    // Comment form validation
    // eslint-disable-next-line no-undef
    if (ideabox_theme_object.is_comment_validation === 'true') {
        $('#commentform').validate({
            submitHandler: function (form) {
                form.submit();
            },
        });

        $.extend($.validator.messages, {
            // eslint-disable-next-line no-undef
            required: ideabox_theme_object.comment_validation,
            // eslint-disable-next-line no-undef
            email: ideabox_theme_object.comment_validation_email,
        });
    }

    $('.sidebar .widget_nav_menu .menu-item-has-children').each(function () {
        $(this).append(
            '<button class="sidebar-alt-menu-toggle" type="button"><i class="material-icons">&#xe145;</i></button>'
        );
    });

    $(document).on('click', '.sidebar-alt-menu-toggle', function () {
        const firstSubMenu = $(this).parent().find('ul:first');

        if (firstSubMenu.length) {
            if (firstSubMenu.css('display') === 'block') {
                $(this).find('i').html('&#xe145;');
            } else {
                $(this).find('i').html('&#xe15b;');
            }

            firstSubMenu.slideToggle(100);
        }
    });
});
